<div class="ui-g-12">
  <app-kontable
  #table data-testid="table"
  title="{{ 'catalog.categoryPrize' | translate }}"
  [columns]="[
      {field: 'id', title: 'ID'},
      {field: 'progres', title: 'common.order'},
      {field: 'code', title: 'common.code'},
      {field: 'description', title: 'common.description'}
  ]"
  [service]="service"
  (onAdd)="showDialog($event)"
  (onEdit)="showDialog($event)"
  (onRemove)="deleteCategory($event.id)"
  [paginationType]="paginationType"
  [showRecoverButton]="false"
  [showInfoButton]="false"
  [showAddButton]="true"
  [showDeleteButton]="true"
  [showDetailsButton]="false"
  [showEditButton]="true"
  [showReport]="true"
  >
  </app-kontable>
</div><br>

<p-dialog
        *ngIf="showCategoryDialog"
        [(visible)]="showCategoryDialog"
        [modal]="true"
        header="{{categoryGiftService.categoryGiftEdit.id ? ('common.edit' | translate) :  ('common.add' | translate) }}
        {{ 'customerShoppingHabits.category' | translate}}"
        [minWidth]="550"
        [draggable]="false"
        [resizable]="false"
        (onHide)="closeDialog()">
    <app-loyalty-catalog-category-form
          (applicationAdded)="applicationAdded($event)"
          (applicationUpdated)="applicationUpdated($event)"
          [dialogCategoryGift]="categoryGiftService.categoryGiftEdit">
    </app-loyalty-catalog-category-form>
</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-catalog-category/loyalty-catalog-category.component.html